import { getInbox, inboxQueryKey, notificationsApiConfigured } from '@/common/apis/services/notifications/inbox';
import { UserInfo } from '@/modules/login/store/userInfo';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { DoctorHomeFeedAlert } from '../types/feed';
import { dedupeNotifications } from '../utils/dedupeNotifications';
import {
  filterNotificationsBySelectedDate,
  getNotificationGregorianDateSet,
} from '../utils/normalizeNotification';
import { useSelectedDateStore } from '../store/selectedDate';
import { doctorHomeQueryDefaults } from '../utils/doctorHomeQuery';
import { useDoctorHomeContext } from './useDoctorHomeContext';

export const useDoctorHomeNotifications = (user?: UserInfo) => {
  const { isDoctor } = useDoctorHomeContext(user);
  const selectedDate = useSelectedDateStore(state => state.selectedDate);
  const notifications = useQuery(inboxQueryKey, getInbox, {
    enabled: isDoctor && notificationsApiConfigured(),
    ...doctorHomeQueryDefaults,
  });

  const allItems = useMemo(() => {
    // Read notifications leave the home; the header bell keeps them under «تاریخچه».
    const raw = (notifications.data?.items ?? []).filter(item => !item.read);
    return raw.map(
      (item): DoctorHomeFeedAlert => ({
        id: item.id,
        title: item.title,
        description: item.body,
        created_at: item.created_at,
        url: item.url,
      }),
    );
  }, [notifications.data?.items]);

  const notificationDateSet = useMemo(
    () => getNotificationGregorianDateSet(dedupeNotifications(allItems)),
    [allItems],
  );

  const itemsForSelectedDate = useMemo(
    () => filterNotificationsBySelectedDate(dedupeNotifications(allItems), selectedDate),
    [allItems, selectedDate],
  );

  return {
    isDoctor,
    items: itemsForSelectedDate,
    notificationDateSet,
    isLoading: notifications.isLoading,
  };
};
